import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { TInvoiceStatus } from '@qapline/core';
import { useCancelInvoiceMutation } from 'modules/invoicing/api';
import { Button } from 'modules/ui';
import { Modal } from 'modules/ui/components/Modal/Modal';

import styles from './StornoInvoiceButton.module.scss';

interface IStornoInvoiceButtonProps {
    invoiceId: number;
    status: TInvoiceStatus;
}

export const StornoInvoiceButton: React.FC<IStornoInvoiceButtonProps> = ({ invoiceId, status }) => {
    const { t } = useTranslation();
    const [showConfirm, setShowConfirm] = useState(false);
    const [cancelInvoice, { isLoading }] = useCancelInvoiceMutation();

    const handleStorno = async () => {
        try {
            await cancelInvoice({ invoiceId }).unwrap();
            toast.success(t('invoicing.storno.success'));
            setShowConfirm(false);
        } catch {
            toast.error(t('invoicing.storno.error'));
        }
    };

    return (
        <div className={styles.wrapper}>
            <Button
                type="button"
                variant="secondary"
                danger
                className={styles.button}
                onClick={() => setShowConfirm(true)}
                disabled={status === 'CANCELED'}
            >
                {t('invoicing.storno.button')}
            </Button>
            {showConfirm && (
                <Modal
                    onClick={() => setShowConfirm(false)}
                    label={t('invoicing.storno.confirmLabel')}
                    description={t('invoicing.storno.confirmDescription')}
                    cancelComponent={
                        <Button type="button" variant="secondary" onClick={() => setShowConfirm(false)}>
                            {t('invoicing.storno.cancel')}
                        </Button>
                    }
                    approveComponent={
                        <Button
                            type="button"
                            variant="primary"
                            danger
                            isLoading={isLoading}
                            disabled={isLoading}
                            onClick={handleStorno}
                        >
                            {t('invoicing.storno.approve')}
                        </Button>
                    }
                />
            )}
        </div>
    );
};
